<template>
  <v-container class="fuel-component mt-1 pa-0 pr-2 pl-3">
    <v-row class="pa-0" v-if="isEditChecklist">
      <v-col cols="12">
        <v-form v-model="valid">
          <v-combobox
            v-bind="propsCombobox"
            @change="updateEmailList"
          ></v-combobox>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
const validEmails = emails => {
  let valid = true;
  for (const email of emails) {
    // eslint-disable-next-line
    if (!/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email))
      valid = false;
  }

  return valid || "Email inválido";
};
export default {
  data() {
    return {
      valid: true,
      propsCombobox: {
        outlined: true,
        items: [],
        label: "Notifica a usuarios por correo",
        multiple: true,
        chips: true,
        rules: [validEmails]
      }
    };
  },
  props: ["isEditChecklist", "accessToEdit"],
  computed: {
    ...mapState("checklist", ["emailNotifications", "validEmailNotifications"])
  },
  methods: {
    ...mapActions("checklist", ["updateEmailNotification"]),
    updateEmailList(emails) {
      if (emails.length > 0) {
        const valid =
          validEmails([...emails]) === "Email inválido" ? false : true;
        this.updateEmailNotification({ emails, valid });
      }
    }
  }
};
</script>
